import isEmpty from './isEmpty';

export default function notEmpty<T>(value: T | undefined | null): value is null | undefined {
  return !isEmpty(value);
}
